module.exports = __webpack_public_path__ + "img/_magic_.659fd082.svg";